<template>
  <div />
</template>

<script>
import yxpapi from '@/extlib/yxpapi';
export default {
    name: 'TransferStation',
    data () {
        return {
            loading: {},
        };
    },
    mounted () {
        let loggingStatus = this.$store.getters['global/isLogin'];
        let self = this;
        self.loading = self.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            // background: 'rgba(0, 0, 0, 0.7)'
        });
        if (loggingStatus) {
            this.$store.dispatch('system/act_clearAccount');
        };
        if (yxpapi.stroage.session.get('yxp-reolad')) {
            yxpapi.stroage.session.remove('yxp-reolad');
            setTimeout(() => {
                window.location.reload();
            }, 500);
        } else if (this.$store.getters['permission/appList'] === null) {
            this.signIn();
        }
    },
    methods: {
        /* 登录系统 */
        signIn () {
            let { userToken = '', uuid = '', equipmentId = '', firstLoginTime = 0 } = this.$route.query;
            if (userToken && uuid) {
                yxpapi.utils.loginByUserToken(userToken, uuid, { firstLoginTime }).then(data => {
                    if (data.errcode === 0) {
                        if (this.$store.getters['permission/appList'].length < 1) {
                            this.backToIndex();
                            return;
                        }
                        this.$store.commit('global/nav/mu_equipment_id', equipmentId);
                        this.$store.dispatch('system/actAuthorize').then(this.next).catch(this.backToIndex);
                    } else {
                        return Promise.reject(data);
                    }
                }).catch((data) => {
                    this.loadError(data.errmsg || data.message || '系统出错！');
                });
            } else {
                this.loadError('请登录');
            }
        },
        /* 系统出错 */
        loadError (msg = '对不起，您暂时没有访问权限！') {
            let self = this;
            let param = {
                backUrl: location.origin + location.pathname,
                path: self.$route.query.backPath || '/',
            };
            if (msg === '请登录' && sessionStorage.getItem('webModulePagePath')) {
                param.noAuthorize = true;
            }
            self.$message({
                type: 'error',
                duration: process.env.NODE_ENV === 'development' ? 0 : 1500,
                showClose: true,
                message: msg,
                onClose () {
                    self.loading.close && self.loading.close();
                    self.$store.dispatch('system/act_login_off', param);
                },
            });
        },
        /* 无访问权限时, 返回首页 */
        backToIndex () {
            let self = this;
            self.$message({
                type: 'error',
                duration: process.env.NODE_ENV === 'development' ? 0 : 1500,
                showClose: true,
                message: '对不起，您暂时没有访问权限！',
                onClose () {
                    if (process.env.NODE_ENV === 'development') {
                        self.$store.dispatch('system/act_login_off', {
                            backUrl: location.origin + location.pathname,
                            path: '/',
                        });
                    } else {
                        self.$store.dispatch('system/act_backToIndex');
                    }
                },
            });
        },
        next () {
            let path = this.$route.query.backPath || sessionStorage.getItem('webModulePagePath') || '/';
            if (sessionStorage.getItem('webModulePagePath')) {
                sessionStorage.removeItem('webModulePagePath');
            }
            this.loading.close && this.loading.close();
            let query = this.$route.query.backParam ? decodeURI(this.$route.query.backParam) : sessionStorage.getItem('webModulePageParam');
            if (query) {
                try {
                    query = JSON.parse(query);
                } catch (e) {}
                if (sessionStorage.getItem('webModulePageParam')) {
                    sessionStorage.removeItem('webModulePageParam');
                }
            }
            const route = {
                path,
            };
            if (query) {
                route.query = query;
            }
            this.$router.replace(route);
        },
    },
};

</script>

<style scoped lang="scss">

</style>
